// Imports
import { useStateValue } from '../../_global/jsx/store';
import { dangerousHTML } from 'src/lib/utils.js';


// Stateful components

export const ReactHome = () => {

    const [{ globalText, componentsData, userData, controlData } , dispatch] = useStateValue();

    // On change handler for select fields
    const selectHandler = (event) =>  {
        // event.preventDefault();        
         
        //console.log(event.target.value);
        let fieldId = event.target.name;
        let selectedValue = event.target.value;
        
        
        let appNameString = globalText.gaAppName;
        let appLabel = event.target.name + ' option: ' + selectedValue;
 
        // console.log(appNameString , appLabel);
         
        //  window.dataLayer.push({"event": "interaction", "target": appNameString, "action": "option selected", "label": (appLabel)}); 
         
         dispatch({
             //type: 'homeOptionSelected',
             type: 'homeOptionSelected',
             value: {
                userResponse: {
                    key: fieldId,
                    value: selectedValue
                }
            }
         });
     }

    // Render the select fields
    const returnSelectFields = () => {
        if(typeof(controlData.currentItem.homeSelectItems) !== 'undefined'){
            
            let hasRequiredField = false;
            let selectFields = controlData.currentItem.homeSelectItems.map((item, idx1) => {

                //let selectedValue = userData.homeResponses[item.assetID] ? userData.homeResponses[item.assetID] : '';
                let selectedValue = userData.questionResponses[item.assetID] ? userData.questionResponses[item.assetID] : '';
                let requiredMark = '';
                if(item.required === "true"){
                    requiredMark = '*';
                    hasRequiredField = true;
                }
                
                return (
                    <div className="br-app-select__group" key={idx1}>
                        
                        <label className="br-app-select__label" htmlFor={"br-app-select__" + idx1}>{item.placeholder + requiredMark}</label>

                        <select id={"br-app-select__" + idx1} name={item.assetID} className="br-app-select" onChange={selectHandler} value={selectedValue}>

                            <option value="" disabled>– Select an option –</option>
                            
                            {
                            
                            Object.keys(item.options).map((option, idx2) => {
                                return <option key={idx2} value={option}>{item.options[option]}</option>
                            })}

                        </select>
                    </div>
                );
            });

            if(hasRequiredField === true){
                selectFields.push(<span key={'requiredNote'} className="br-app-select__note">*Required</span>);
            }
            

            return selectFields;

        }else{
            return ;
        }
    }


    return (
        <div>
            
            <div className="br-app-select__wrapper">
                {returnSelectFields()}
                
            </div>
            

            <div className="br-app-main-content__support" dangerouslySetInnerHTML={dangerousHTML(controlData.currentItem.homeContent)}></div>
            
        </div>
    );    
};
